module.exports = __webpack_public_path__ + "06474e5e592f18ae4a86977dffe4daac.jpg";